const importLogReport = {
    namespaced: true,
    state: {
        importLogTypesList: [],
        importLogsList: []
    },
    mutations: {
        updateImportLogTypesList(state, newList) {
            state.importLogTypesList = newList;
        },
        updateImportLogsList(state, newList) {
            state.importLogsList = newList;
        },
        clearImportLogsList(state) {
            state.importLogsList = [];
        }

    },
    actions: {
        getImportLogTypes(context) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/importLogReport/getImportLogTypes')
                    .then(response => {
                        context.commit('updateImportLogTypesList', response.data);
                        resolve(response.data);
                    }),
                error => {
                    reject(error);
                }
            });
        },
        getImportLogs(context, data) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/importLogReport/getImportLogs', {params: {"importlogtype": data.importlogtype, "logdate": data.logdate}})
                    .then(response => {
                        context.commit('updateImportLogsList', response.data);
                        resolve(response.data);
                    }),
                error => {
                    reject(error);
                }
            });
        }
    }
}

export default importLogReport;